export default function ToiletsData() {
    window.location.href = 'https://twitter.com/sabancivakfi/status/1625146826335694849?s=46&t=XcGyniD8_Ur8EiwgP61Gqg';
    return <h2><b>Sabancı Vakfı</b>'na yönlendiriliyorsunuz...</h2>;
}
  